var $, old;

$ = window.jQuery;

old = $.fn.getTarget;


/*
Returns the target element specified in the selected element's `data-target`
attribute. Fals back to the `href` attribute (standard id search). Will return
null if no attribute is found.

    <div id="example-1" data-target="#element-1"></div>
    <div id="example-2"></div>
    <a id="example-3" href="#element-2"></a>

    $('#example-1').getTarget()
    > [<div id="element-1"></div>]
    $('#example-2').getTarget()
    > null
    $('#example-3').getTarget()
    > [<div id="element-2"></div>]
 */

$.fn.getTarget = function() {
  var element, selector, target;
  element = $(this);
  selector = element.data('target');
  if (selector instanceof $) {
    return selector;
  }
  if (!selector) {
    selector = element.attr('href');
    selector = selector && /^#/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '');
  }
  target = selector && $(selector);
  if (target != null ? target.length : void 0) {
    element.data('target', target);
    return target;
  } else {
    return null;
  }
};

$.fn.getTarget.noConflict = function() {
  $.fn.getTarget = old;
  return this;
};
